var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolioRoundedSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H118C123.523 0 128 4.47715 128 10V118C128 123.523 123.523 128 118 128H10C4.47715 128 0 123.523 0 118V10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H118C123.523 0 128 4.47715 128 10V118C128 123.523 123.523 128 118 128H10C4.47715 128 0 123.523 0 118V10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19C24 16.2386 26.2386 14 29 14H99C101.761 14 104 16.2386 104 19V109C104 111.761 101.761 114 99 114H29C26.2386 114 24 111.761 24 109V19Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25C31 22.2386 33.2386 20 36 20H91C93.7614 20 96 22.2386 96 25V103C96 105.761 93.7614 108 91 108H36C33.2386 108 31 105.761 31 103V25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76.5C48 79.5376 45.5376 82 42.5 82C39.4624 82 37 79.5376 37 76.5C37 73.4624 39.4624 71 42.5 71C45.5376 71 48 73.4624 48 76.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48 94.5C48 97.5376 45.5376 100 42.5 100C39.4624 100 37 97.5376 37 94.5C37 91.4624 39.4624 89 42.5 89C45.5376 89 48 91.4624 48 94.5Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54 76C54 73.7909 55.7909 72 58 72H86C88.2091 72 90 73.7909 90 76V77C90 79.2091 88.2091 81 86 81H58C55.7909 81 54 79.2091 54 77V76Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94C54 91.7909 55.7909 90 58 90H86C88.2091 90 90 91.7909 90 94V95C90 97.2091 88.2091 99 86 99H58C55.7909 99 54 97.2091 54 95V94Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44 50.4286V64H49.3793V54.5C49.3793 51.2429 51.8448 49.0714 53.4138 49.0714C55.431 49.0714 60.1379 49.75 60.1379 47.0357C60.1379 44.3214 60.1379 45 58.7931 43.6429C58.0324 42.8751 57.4483 40.0238 57.4483 38.2143C57.4483 35.9524 58.7931 31.4286 64.1724 31.4286C69.5517 31.4286 70.8966 35.9524 70.8966 38.2143C70.8966 40.0238 70.3125 42.8751 69.5517 43.6429C68.2069 45 68.2069 44.3214 68.2069 47.0357C68.2069 49.75 72.2414 49.0714 74.2586 49.0714C75.3793 49.0714 77.6207 51.2429 77.6207 54.5V64H83V50.4286C83 46.0857 79.4138 45 77.6207 45H74.2586C74.931 44.0952 76.2759 41.4714 76.2759 38.2143C76.2759 34.1429 74.931 26 64.1724 26C53.4138 26 52.069 34.1429 52.069 38.2143C52.069 41.4714 53.4138 44.0952 54.0862 45H49.3793C45.0759 45 44 48.619 44 50.4286Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioRoundedSquare);
export default __webpack_public_path__ + "static/media/portfolio-rounded-square.4ce51bb8306b801d9e532a9cb680df02.svg";
export { ForwardRef as ReactComponent };